import React from 'react';
import styles from './ManagePlatformProducts.module.scss';
import { Button, Col, Row } from 'reactstrap';
import { utils, writeFile } from 'xlsx';
import ManageTable from '../../../../Manage/ManageTable';

const data = [
    {
        id: 1,
        productImg: require("../../../../../assets/images/SellerPortalImages/DashboardImages/OverviewPanelImages/OrderProductImg.png"),
        name: 'Blue Colored Headphones',
        productId: '367658',
        sku: 'voilet89a',
        category: 'Health & Beauty',
        brand: 'No brand',
        inboundStatus: 'Not ready',
        productStatus: 'Online',
    },
    {
        id: 2,
        productImg: require("../../../../../assets/images/SellerPortalImages/DashboardImages/OverviewPanelImages/OrderProductImg.png"),
        name: 'Blue Colored Headphones',
        productId: '367658',
        sku: 'voilet89a',
        category: 'Health & Beauty',
        brand: 'No brand',
        inboundStatus: 'Not ready',
        productStatus: 'Online',
    },
    {
        id: 3,
        productImg: require("../../../../../assets/images/SellerPortalImages/DashboardImages/OverviewPanelImages/OrderProductImg.png"),
        name: 'Blue Colored Headphones',
        productId: '367658',
        sku: 'voilet89a',
        category: 'Health & Beauty',
        brand: 'No brand',
        inboundStatus: 'Not ready',
        productStatus: 'Online',
    },
    {
        id: 4,
        productImg: require("../../../../../assets/images/SellerPortalImages/DashboardImages/OverviewPanelImages/OrderProductImg.png"),
        name: 'Blue Colored Headphones',
        productId: '367658',
        sku: 'voilet89a',
        category: 'Health & Beauty',
        brand: 'No brand',
        inboundStatus: 'Not ready',
        productStatus: 'Online',
    },
    {
        id: 5,
        productImg: require("../../../../../assets/images/SellerPortalImages/DashboardImages/OverviewPanelImages/OrderProductImg.png"),
        name: 'Blue Colored Headphones',
        productId: '367658',
        sku: 'voilet89a',
        category: 'Health & Beauty',
        brand: 'No brand',
        inboundStatus: 'Not ready',
        productStatus: 'Online',
    },
    {
        id: 6,
        productImg: require("../../../../../assets/images/SellerPortalImages/DashboardImages/OverviewPanelImages/OrderProductImg.png"),
        name: 'Blue Colored Headphones',
        productId: '367658',
        sku: 'voilet89a',
        category: 'Health & Beauty',
        brand: 'No brand',
        inboundStatus: 'Not ready',
        productStatus: 'Online',
    },
];

const columns = [
    {
        name: 'Image',
        cell: (row) => <img src={row.productImg} alt={row.name} className={styles.productImg} />,
    },
    {
        name: 'Product Name',
        selector: (row) => row.name,
        sortable: true,
        minWidth: "200px",
        maxWidth: '250px',
    },
    {
        name: 'Product ID',
        selector: (row) => row.productId,
        sortable: true,
        minWidth: "120px",
    },
    {
        name: 'Seller SKU',
        selector: (row) => row.sku,
        sortable: true,
        minWidth: "120px",
    },
    {
        name: 'Product Category',
        selector: (row) => row.category,
        sortable: true,
        minWidth: "160px",
    },
    {
        name: 'Brand',
        selector: (row) => row.brand,
    },
    {
        name: 'Inbound Status',
        selector: (row) => row.inboundStatus,
        minWidth: "140px",
    },
    {
        name: 'Product Status',
        selector: (row) => row.productStatus,
        minWidth: "140px",
    },
];

const ManagePlatformProducts = () => {

    const handlePrint = () => {
        window.print();
    };

    const handleExportExcel = () => {
        const worksheet = utils.json_to_sheet(data);
        const workbook = utils.book_new();
        utils.book_append_sheet(workbook, worksheet, 'Products');
        writeFile(workbook, 'ManagePlatformProducts.xlsx');
    };

    return (
        <div className={styles.mainManageProductsContainer}>
            <h4 className={styles.sectionHeading}>Manage Platform Products</h4>

            <div className={styles.manageProducts}>

                <Row className={styles.totalProducts}>
                    <Col lg={"auto"} className={styles.totalProductsContainer}>
                        <span>Total Products: 300</span>
                    </Col>
                    <Col lg={"auto"} className={styles.btnsContainer}>
                        <Button type="button" onClick={handlePrint}>
                            Print
                        </Button>
                        <Button type="button" onClick={handleExportExcel}>
                            Export
                        </Button>
                    </Col>
                </Row>

                <ManageTable
                    name={'Manage Platform Products'}
                    columns={columns}
                    tableData={data}
                />
            </div>
        </div>
    )
}

export default ManagePlatformProducts;